export var TAG_REPOSITORY = 'TAG_REPOSITORY';